import { jsx as _jsx } from "react/jsx-runtime";
import { StoresItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = (props) => _jsx(StoresItem, { isAdd: true, ...props });
export default Add;
